module.exports = __webpack_public_path__ + "media/images/mr1-f0b60af30e10d7b22d832db0359ec424.jpg";